import { slick } from 'slick-carousel';
export default {
  init() {
    $('.timeline').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows:true,
      infinite : true,
      initialSlide : 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide : 6,
            infinite: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide : 8,
            infinite: true,
            arrows:true,
          }
        }
      ]
    });

    // Hover states

    $('.event-name').hover(function(){
      $(this).find('> .hover-front').stop(true, true).toggleClass('hidden');
      $(this).find('> .hover-back').stop(true, true).toggleClass('hidden');
    }, function(){
      $(this).find('> .hover-back').stop(true, true).toggleClass('hidden');
      $(this).find('> .hover-front').stop(true, true).toggleClass('hidden');
    })
  },
  finalize() {}
}